var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(_vm.board.type === 'c')?_c('TicketsColumns',{attrs:{"board":_vm.board}}):_vm._e(),(_vm.board.type === 'l')?_c('TicketsList',{attrs:{"board":_vm.board}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }